import fetchClient from "api/client";
import CAMPAIGNS_ENDPOINT from "./campaignsEndpoint";

/**
 * @description POST /api/campaigns/:campaignId/rules
 * @param {object} payload - The payload object.
 * @param {number|string} payload.campaignId - The ID of the campaign.
 * @param {object} payload.body - The rule data to be created.
 * @returns {Promise}
 */
export default function createPhaseRule({ campaignId, body }) {
  if (!campaignId) {
    return Promise.reject(new Error("Campaign ID is required."));
  }

  const url = `${CAMPAIGNS_ENDPOINT}/${campaignId}/rules`;

  return fetchClient.post(url, { body });
}
